import { ChevronLeft, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';

class DataReportingPerSalesMobile extends Component {
    state = {  } 
    render() { 
        return (
        <Box>
            <NavbarMobile title={"Data Reporting Per Sales"} {...this.props} />
            <Box sx={{padding: "10px"}}>
                <Filter {...this.props} />
                {
                    this.props.perSales?.map((lead,index) => {
                        return (
                            // <TableCell>{item.sales}</TableCell>
                            // <TableCell>{item.leadsOriginal}</TableCell>
                            // <TableCell>{item.leadsPending}</TableCell>
                            // <TableCell>{item.leadsCross}</TableCell>
                            // <TableCell>{item.leadsCrossDiterima}</TableCell>
                            // <TableCell>{item.closingOriginal}</TableCell>
                            // <TableCell>{item.closingCross}</TableCell>
                            // <TableCell>{item.leadsOriginal > 0 ? (item.closingOriginal/item.leadsOriginal*100).toFixed(2) : 0}</TableCell>
                            // <TableCell>{item.leadsCrossDiterima > 0 ? (item.closingCross/item.leadsCrossDiterima*100).toFixed(2) : 0}</TableCell>
                            // <TableCell>{((item.closingOriginal+item.closingCross)/(item.leadsOriginal+item.leadsCrossDiterima)*100).toFixed(2)}</TableCell>
                            <Accordion key={`cross-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">{lead.sales}</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                           {((lead.closingOriginal+lead.closingCross)/(lead.leadsOriginal+lead.leadsCrossDiterima)*100).toFixed(2).replace(".00", "")}%
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">Leads Original</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                            {lead.leadsOriginal}
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">Leads Pending</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                            {lead.leadsPending}
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">Closing original</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                            {lead.closingOriginal}
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">Closing Cross</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                            {lead.closingCross}
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">Closing Rate Original</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                            {lead.leadsOriginal > 0 ? (lead.closingOriginal/lead.leadsOriginal*100).toFixed(2).replace(".00", "") : 0}%
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">Closing Rate Cross</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                            {((lead.closingOriginal+lead.closingCross)/(lead.leadsOriginal+lead.leadsCrossDiterima)*100).toFixed(2).replace(".00", "")}%
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                }
            </Box>
        </Box>
        );
    }
}
 
export default DataReportingPerSalesMobile;